import styled from 'styled-components'
import {
  COLOR,
  FONT_SIZE,
  Z_INDEXS
} from '../../themes'
const Style = styled.div`
  display: flex;
  flex-flow: row nowrap;
  margin: 6px 0 auto 0;
  padding: 0;
  height: 100%;
  align-items: stretch;
  justify-content: stretch;
  align-self: stretch;
  color: ${COLOR.BLACK_1};
  font-size: ${FONT_SIZE.TN};
  line-height: 24px;

  .checkbox-container {
    position: relative;
    display: block;
    height: 24px;
    width: 24px;
    border: none;
    border-radius: 2px;
    margin: 0;
    margin-right: 8px;
    overflow: hidden;
    color: ${COLOR.GRAY_6};
  }
  .checkbox-container > * {
    width: 100%;
    height: 100%;
    opacity: 0;
    position: absolute;
    top: 0;
    left: 0;
    margin: 0;
    padding: 0;
    z-index: ${Z_INDEXS.LV_0};
    cursor: pointer;
  }
  .checkbox-container > .square {
    opacity: 1;
  }
  .checkbox-container:hover > .square {
    opacity: 1;
  }
  .checkbox-container:focur > .square {
    color: ${COLOR.GOLD_1};
    opacity: 1;
  }
  .checkbox-container input {
    z-index: ${Z_INDEXS.LV_1};
  }
  .checkbox-container input:checked ~ .checkmark {
    color: ${COLOR.GOLD_1};
    opacity: 1;
  }
  .checkbox-container > .checkmark {
    transition: opacity 50ms ease-in;
  }
  .disabled,
  .disabled ~ * {
    color: ${COLOR.GRAY_2} !important;
    cursor: not-allowed !important;
  }
`

export default Style
